module.exports = __webpack_public_path__ + "img/Twitter.23972a15.svg";